<template>
  <div>
    <step01
      v-if="currentStep === 1"
      :limit-fellow-driver-count="options.limitFellowDriverCount"
      :limit-fellow-driver26-down-count="options.limitFellowDriver26DownCount"
      :block-second-license="options.blockSecondLicense"
      :user-checker="checkUser"
      :data="application.fellowDrivers"
      :user-email="userEmail"
      @next="beforeMove(2, $event)"
    />

    <step02
      v-if="currentStep === 2"
      :additional-price="additionalPrice"
      :user-cards="options.userCards"
      :data="application.fellowDrivers"
      :billing-id="application.billingId"
      @back="move(1)"
      @next="beforeMove(3)"
    />

    <step03
      v-if="currentStep === 3"
      :data="application"
    />

    <loading v-if="isLoading" />
  </div>
</template>

<script>

import { assign, get, toNumber, filter, map, isEmpty } from 'lodash';
import ApiClient, { API } from 'api/client';
import Loading from 'components/Loading';
import Step01 from './additional/Step01';
import Step02 from './additional/Step02';
import Step03 from './additional/Step03';
import DialogUtil from 'utils/dialog';
import config from 'config';
import { isWebview } from 'utils/webview/isWebview';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { closeWebView } from 'utils/webview/closeWebView';

export default {
  name: 'Additional',
  components: {
    Step01,
    Step02,
    Step03,
    Loading,
  },
  mixins: [ApiClient],
  props: {
    step: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      currentStep: toNumber(this.step),
      isLoading: false,
      options: {
        limitFellowDriverCount: 4,
        limitFellowDriver26DownCount: 4,
        blockSecondLicense: false,
      },
      application: {
        contractId: null,
        hashingContractId: null,
        id: null,
        billingId: null,
        priceId: null,
        fellowDrivers: [],
        fellowDriver26UpCount: null,
        fellowDriver26DownCount: null,
      },
      additionalPrice: {
        total: 0,
      },
    };
  },
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    userEmail() {
      return this.$store.state.user.email;
    },
    valid() {
      // const application = reduce(this.application, (result, val) => (result && val != null), true);
      // const additional = true; // reduce(this.additional, (result, val) => (result && val), true);
      // const termsAgree = reduce(this.agreeTerms, (result, val) => (result && val), true);
      // return (application && additional && termsAgree);
      return true;
    },
  },
  watch: {
    '$route'() {
      this.currentStep = toNumber(this.step);
    },
  },
  async created() {
    const hashingContractId = this.$route.query.contractId;
    if (isEmpty(hashingContractId)) {
      DialogUtil.alert('잘못된 접근입니다.\n플랜 홈으로 이동합니다.');

      if (isWebview()) {
        postMessageToPlanHome('/');
        closeWebView();
        return;
      }
      window.location.href = config.planHome.baseURL;
    }
    if (!this.$store.state.user.logged) {
      // router에서 강제로 redirect 된 경우에는 alert 표시하지 않고 바로 로그인으로 보냄
      if (get(this.$route.query, 'force', 'false') !== 'true') {
        DialogUtil.alert('로그인이 필요합니다.');
        this.$router.replace({ path: `/login?redirect=/application/additional?contractId=${hashingContractId}` });
      } else {
        await this.$router.replace('/login?redirect=/application/main');
      }
    } else {
      this.isLoading = true;
      const CodeApi = this.getApi(API.CODE);
      const ContractApi = this.getApi(API.CONTRACT);
      // const { contractId, billingId, priceId, limitFellowDriverCount, limitFellowDriver26DownCount, blockSecondLicense } = await ContractApi.getContractAdditional({ contractId: hashingContractId });

      await ContractApi.getContractAdditional({ contractId: hashingContractId })
        .then(async ({ contractId, billingId, priceId, limitFellowDriverCount, limitFellowDriver26DownCount, blockSecondLicense }) => {
          this.application.contractId = contractId;
          this.application.billingId = billingId;
          this.application.priceId = priceId;
          const userCards = await CodeApi.getBillings();
          // 신청가능 추가운전자 인원수 조회
          this.options.limitFellowDriverCount = limitFellowDriverCount;
          this.options.limitFellowDriver26DownCount = limitFellowDriver26DownCount;
          // 1종면허만 가능 여부
          this.options.blockSecondLicense = blockSecondLicense;
          // 사용자 카드 목록
          this.options.userCards = userCards;
          this.isLoading = false;
        })
        .catch(() => {
          this.$router.push('/application');
        });
    }
  },
  methods: {
    async move(step) {
      this.currentStep = step;
      await this.$router.push({ path: `/application/additional/${step}` });
    },
    async beforeMove(step, data) {
      this.application = assign({}, this.application, data);
      switch (step) {
        case 2:
          this.additionalPrice = await this.getAdditionalPrice();
          break;
        case 3: {
          const result = await DialogUtil.confirm('결제를 진행하시겠습니까?', async() => {
            await this.submit();
            return true;
          });
          if (result !== true) return;
        }
          break;
        default:
          // skip
      }
      await this.move(step);
    },
    async checkUser(userId) {
      const ContractApi = this.getApi(API.CONTRACT);
      const { memberId, name, age, liLv } = await ContractApi.getFellowDriverInfo({ userId });
      return { memberId, userId, name, age, liLv };
    },
    async getAdditionalPrice() {
      this.application.fellowDriver26UpCount = filter(this.application.fellowDrivers, (item) => (item.age >= 26)).length;
      this.application.fellowDriver26DownCount = filter(this.application.fellowDrivers, (item) => (item.age < 26)).length;
      const ContractApi = this.getApi(API.CONTRACT);
      const { fee } = await ContractApi.getFellowDriverFee({ priceId: this.application.priceId, fellowDriver26UpCount: this.application.fellowDriver26UpCount, fellowDriver26DownCount: this.application.fellowDriver26DownCount });
      return { total: fee };
    },
    async submit() {
      const ContractApi = this.getApi(API.CONTRACT);
      const data = {
        contractId: this.application.contractId,
        fellowDriver26UpCount: this.application.fellowDriver26UpCount,
        fellowDriver26DownCount: this.application.fellowDriver26DownCount,
        fellowDriverIds: map(this.application.fellowDrivers, (item) => (item.memberId)),
      };
      const result = await ContractApi.createFellowDriver(data);
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.divider-margin {
  margin: 50px 0 50px 0;
}
.bottom-button {
  padding: 5px 5px 5px 5px;
}
</style>
